import { render, staticRenderFns } from "./BeReadyStatusUpdate.vue?vue&type=template&id=573b5f3f"
import script from "./BeReadyStatusUpdate.vue?vue&type=script&lang=js"
export * from "./BeReadyStatusUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports